import { Component, computed, signal } from '@angular/core';
import { DashboardRoute, InvestmentsListRoute, BlogRoute, CollaboratorRoute, ProductLandingRoute } from 'src/models/routes.model';

export interface HeaderSubmenuTile {
  icon: string;
  productsKey: string;
  route: string;
  fragment?: string;
}
@Component({
  selector: 'liberro-basic-layout-header-links',
  standalone: false,
  templateUrl: './basic-layout-header-links.component.html',
  styleUrl: './basic-layout-header-links.component.less',
})
export class BasicLayoutHeaderLinksComponent {
  public productsPopupActive = signal<boolean>(false);
  public productsLinkHovered = signal<boolean>(false);
  public popupExplicitlyHidden = signal<boolean>(false);
  public productsLinkActive = computed<boolean>(() => this.productsPopupActive() || this.productsLinkHovered());

  public dashboardRoute = `/${DashboardRoute.DASHBOARD}`;
  public collaboratorRoute = `/${CollaboratorRoute.COLLABORATOR}`;
  public investmentsRoute = `/${InvestmentsListRoute.INVESTMENTS}`;
  public blogRoute = `/${BlogRoute.BLOG}`;

  public productsSubmenuTiles: HeaderSubmenuTile[] = [
/*     {
      icon: 'assets/icons/user-stats.svg',
      productsKey: 'portfolio',
      route: '',
    }, */
    {
      icon: 'assets/icons/heart-circle.svg',
      productsKey: 'thematicStrategy',
      route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.THEMATIC_STRATEGY}`,
    },
    {
      icon: 'assets/icons/chart.svg',
      productsKey: 'customStrategy',
      route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.CUSTOM_STRATEGY}`,
    },
/*     {
      icon: 'assets/icons/coins-money.svg',
      productsKey: 'dip',
      route: '',
    } */
  ];

  public productsPopupStart(): void {
    if (!this.popupExplicitlyHidden()) {
      this.productsPopupActive.set(true);
    }
  }

  public productsPopupEnd(): void {
    // time adjustment for chevron toggle
    setTimeout(() => {
      this.productsPopupActive.set(false);
      this.popupExplicitlyHidden.set(false);
    }, 500);
  }

  public productsLinkHoverStart(): void {
    if (!this.popupExplicitlyHidden()) {
      this.productsLinkHovered.set(true);
    }
  }

  public productsLinkHoverEnd(): void {
    // time adjustment for chevron toggle
    setTimeout(() => {
      this.productsLinkHovered.set(false);
      this.popupExplicitlyHidden.set(false);
    }, 500);
  }

  public hidePopup(): void {
    this.popupExplicitlyHidden.set(true);
    this.productsPopupActive.set(false);
    this.productsLinkHovered.set(false);
  }

}
